<template>
  <div id="app">
    <Toast position="top-right" />
    <ConfirmPopup/>
    <router-view />
  </div>
</template>

<script setup>
import Toast from 'primevue/toast'

import { useToast } from 'primevue/usetoast';
import { toastService } from '@services/plugins/toast';
const toast = useToast();
toastService.setToastInstance(toast);
</script>